export default __webpack_public_path__ + "static/media/R (1).f794516a.jpg";